import {ExternalLink} from 'lucide-react';
import type {ReactNode} from 'react';
import {Fragment} from 'react';
import {useTranslation} from 'react-i18next';

import {Button} from '@/components/ui/button';

export type FormPreviewInput = {
  key: string;
  label: string;
  value?: ReactNode;
  isUrl?: boolean;
};

export type FormPreviewProps = {
  items: FormPreviewInput[];
  hideEmpty?: boolean;
};

const FormPreview = ({items, hideEmpty}: FormPreviewProps) => {
  const filteredItems = hideEmpty ? items.filter(item => item.value) : items;
  const {t} = useTranslation();

  return (
    <dl className="grid grid-cols-1 items-start gap-y-1 sm:grid-cols-[minmax(120px,max-content)_1fr] sm:items-center sm:gap-x-6 sm:gap-y-4">
      {filteredItems.map(item => (
        <Fragment key={item.key}>
          <dt className="text-marian">{item.label}:</dt>
          <dd className="min-w-0 pb-3 sm:pb-0">
            {item.isUrl ? (
              <Button
                asChild
                variant="link"
                size="text"
                className="w-fit max-w-full justify-start gap-1 text-sm"
              >
                <a
                  href={item.value! as string}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ExternalLink size={14} className="shrink-0" />
                  <span className="truncate">{t('Download')}</span>
                </a>
              </Button>
            ) : (
              item.value
            )}
          </dd>
        </Fragment>
      ))}
    </dl>
  );
};

export default FormPreview;
